module.exports = __webpack_public_path__ + "static/media/Doug-Logo-Red.62f97d0f.svg";